import styled, { css } from 'styled-components'
import { breakpoint } from '../layout/styles'
import { Content } from './Banner'

export const Component = styled.section<any>`
  width: 100%;
  align-items: center;
  display: flex;
  flex-direction: columnl
  @media ${breakpoint.desktop} {
    flex-direction: row;
    min-height: var(--component-height, 42rem);
  }
`
export const Wrapper = styled.div<any>`
  position: relative;
  width: 100%;
  ${props => (!props.variant || props.variant !== 'full') && css`
    max-width: 1120px;
    margin: 0 auto;
  `}
`

export const FadeInArea = styled.div<any>`
  transition: all 1s ease;
  transform: translateY(75px);
  opacity: 0;
  ${props => props.inView && css`
    transform: translateY(0);
    opacity: 1;
  `}
`